import { render, staticRenderFns } from "./Enrolment.vue?vue&type=template&id=c268c224&"
import script from "./Enrolment.vue?vue&type=script&lang=js&"
export * from "./Enrolment.vue?vue&type=script&lang=js&"
import style0 from "./Enrolment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports